import { render, staticRenderFns } from "./AssetIconManager.vue?vue&type=template&id=10c3b602&scoped=true"
import script from "./AssetIconManager.vue?vue&type=script&lang=ts"
export * from "./AssetIconManager.vue?vue&type=script&lang=ts"
import style0 from "./AssetIconManager.vue?vue&type=style&index=0&id=10c3b602&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c3b602",
  null
  
)

export default component.exports